import { NeoModel, ValueObject } from "@singularsystems/neo-core";
import FileGroupingFileSpecImportProcedureLookup from "../Lookups/FileGroupingFileSpecImportProcedureLookup";

@NeoModel
export default class GetImportProcedureListQuery extends ValueObject {
    public managedProcedure = new FileGroupingFileSpecImportProcedureLookup();
}